import React from 'react'
import { Heading } from '../HeadingModule/Heading'
import '../../styles/DisclosureModule/DisclosureHeading.scss'

export interface DisclosureHeadingProps {
  heading: string
  fallback: string
}

export const DisclosureHeading = ({ heading, fallback }: DisclosureHeadingProps) => {
  return (
    <Heading
      text={heading || fallback}
      as="h2"
      className="disclosure-heading"
      id="disclosure-heading"
    />
  )
}
